/** Base URL: empty in dev so calls hit the Vite proxy (/api → backend). */
export const API_BASE_URL: string = (import.meta.env.API_BASE_URL || '').replace(/\/$/, '');
export const API_PREFIX = '/api/v1';

export const GOOGLE_CLIENT_ID: string = import.meta.env.GOOGLE_CLIENT_ID || '';
export const APPLE_CLIENT_ID: string = import.meta.env.APPLE_CLIENT_ID || '';
export const WEBAUTHN_RP_ID: string | undefined = import.meta.env.WEBAUTHN_RP_ID || undefined;

/** GA4 Web data stream, in the SAME property as the mobile app. Empty disables analytics entirely. */
export const GA_MEASUREMENT_ID: string = import.meta.env.GA_MEASUREMENT_ID || '';

export const FIREBASE = {
  apiKey: import.meta.env.FIREBASE_API_KEY || '',
  projectId: import.meta.env.FIREBASE_PROJECT_ID || '',
  messagingSenderId: import.meta.env.FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.FIREBASE_APP_ID || '',
  vapidKey: import.meta.env.FIREBASE_VAPID_KEY || '',
};
export const PUSH_ENABLED = !!(FIREBASE.apiKey && FIREBASE.projectId && FIREBASE.messagingSenderId && FIREBASE.appId && FIREBASE.vapidKey);

export const REVENUECAT = {
  apiKey: import.meta.env.REVENUECAT_WEB_API_KEY || '',
  entitlement: import.meta.env.REVENUECAT_ENTITLEMENT || 'pro',
};
export type BillingProvider = 'stripe' | 'revenuecat' | '';
export const BILLING_PROVIDER: BillingProvider = ((import.meta.env.BILLING_PROVIDER || '').toLowerCase() as BillingProvider) || (REVENUECAT.apiKey ? 'revenuecat' : '');
export const BILLING_PORTAL_URL: string = import.meta.env.BILLING_PORTAL_URL || '';
export const BILLING_ENABLED = BILLING_PROVIDER === 'stripe' || (BILLING_PROVIDER === 'revenuecat' && !!REVENUECAT.apiKey);

/** Injected from package.json at build time; the release tag is verified against it in CI. */
export const APP_VERSION: string = import.meta.env.APP_VERSION || '0.0.0';

export function apiUrl(path: string): string {
  return `${API_BASE_URL}${API_PREFIX}${path}`;
}
